const middleware = {}

middleware['base-data'] = require('../middleware/base-data.js')
middleware['base-data'] = middleware['base-data'].default || middleware['base-data']

export default middleware
